import {
  ORDER,
  GET_CART,
  GET_HOMES,
  AUTH_START,
  UPDATE_CART,
  GET_ADDRESS,
  PRODUCT_END,
  ADD_ADDRESS,
  ADD_TO_CART,
  PRODUCTS_END,
  PRODUCTS_ERROR,
  PRODUCTS_START,
  GET_CATEGORIES,
  GET_CATEGORY_PRODUCTS,
  GET_FAVOURITES,
  DELETE_ADDRESS,
  REMOVE_FROM_CART,
  UPDATE_FAVOURITES,
  UNATHENTICATED_CART,
  REMOVE_FAVOURITES,
  PRODUCT_LOAD,
  CLEAR_CART,
  GET_ADVERTS,
  GET_POPUP_ADVERT,
  GET_COUPON,
  CLEAR_COUPON,

} from "store/actions/actions.types";
import { INIT_STATE_BUSINESS } from "store/initialstates";
import { getDeliveryFee } from 'utils/helpers.js'

const RESET_COUPON = {
  code: "",
  price: 0,
  meta: null,
};

const computeDeliveryFee = (cartLike) => {
  const fee = getDeliveryFee() ?? {};
  const { base_price = 0, kg_price = 0 } = fee;
  const items = Array.isArray(cartLike) ? cartLike : [];
  const totalKg = items
    .map((row) => {
      const w = +row?.product?.weight || 0;
      const q = +row?.quantity || 0;
      return w * q;
    })
    .reduce((a, b) => a + b, 0);
  return totalKg * (+kg_price || 0) + (+base_price || 0);
};

const businessReducer = (state = INIT_STATE_BUSINESS, action) => {
  switch (action.type) {
    case AUTH_START:
      return { ...state, loading: true };

    case PRODUCTS_START:
      return { ...state, loading: true, productLoading: true };

    case PRODUCTS_ERROR:
      return { ...state, loading: false, productLoading: false };

    case PRODUCTS_END:
      return { ...state, loading: false, products: action.payload, productLoading: false };

    case GET_CATEGORY_PRODUCTS:
      return { ...state, loading: false, categoryProducts: action.payload, productLoading: false };

    case PRODUCT_LOAD:
      return { ...state, productLoading: true }

    case PRODUCT_END:
      return { ...state, loading: false, product: action.payload, productLoading: false };

    case GET_CATEGORIES:
      return {
        ...state, loading: false,
        categories: action.payload?.filter((data) => String(data?.visible) === '1'),
        allCategories: action.payload
      };

    case GET_FAVOURITES:
      console.log(action.payload)
      return {
        ...state,
        favourites: action.payload,
        productLoading: false
      };

    case REMOVE_FAVOURITES:

      return {
        ...state,
        favourites: state.favourites.filter((data) => data?.uuid !== action.payload)
      };

    case UPDATE_FAVOURITES:

      return {
        ...state,
        favourites: [...state.favourites, action.payload]
      };

    case GET_COUPON:
      return {
        ...state,
        couponAmount: action.payload
      }

    case CLEAR_COUPON:
      return {
        ...state,
        couponAmount: RESET_COUPON,
      }

    case GET_HOMES:
      return { ...state, loading: false, homes: action.payload };

    case ADD_ADDRESS:
      return { ...state, loading: false, address: [...state.address, action.payload] }

    case ORDER:
      return { ...state, cart: [], couponAmount: RESET_COUPON, deliveryFee: 0 }

    case CLEAR_CART:
      return { ...state, cart: [], couponAmount: RESET_COUPON, deliveryFee: 0 }

    case ADD_TO_CART: {
      const cart = state.cart ?? []

      const incomingKey = action.payload?.product?.id ?? action.payload?.product?.uuid;
      const findProductIncart = cart.find((data) => {
        const key = data?.product?.id ?? data?.product?.uuid;
        if (key == null || incomingKey == null) return false;
        return String(key) === String(incomingKey);
      });
      if (findProductIncart) {
        const nextCartInc = cart.map((data) => {
          const key = data?.product?.id ?? data?.product?.uuid;
          const inKey = action.payload?.product?.id ?? action.payload?.product?.uuid;
          if (key != null && inKey != null && String(key) === String(inKey)) {
            data.quantity = +data.quantity + +action.payload.quantity;
          }
          return data
        });
        return {
          ...state,
          cart: nextCartInc,
          deliveryFee: computeDeliveryFee(nextCartInc),
        };
      }
      const nextCartAdd = [...cart, action.payload];
      return {
        ...state,
        cart: nextCartAdd,
        deliveryFee: computeDeliveryFee(nextCartAdd),
        couponAmount: RESET_COUPON,
      }
    }
    case GET_ADVERTS:
      return {
        ...state,
        adverts: action.payload
      }
    case GET_POPUP_ADVERT:
      return {
        ...state,
        popupAdvert: action.payload
      }
    case UNATHENTICATED_CART: {

      const cartItems = state.cart ?? []
      const incomingKeyI = action.payload?.product?.id ?? action.payload?.product?.uuid;
      const findProductIncartI = cartItems.find((data) => {
        const key = data?.product?.id ?? data?.product?.uuid;
        if (key == null || incomingKeyI == null) return false;
        return String(key) === String(incomingKeyI);
      });
      if (findProductIncartI) {
        const nextCartInc = cartItems.map((data) => {
          const key = data?.product?.id ?? data?.product?.uuid;
          const inKey = action.payload?.product?.id ?? action.payload?.product?.uuid;
          if (key != null && inKey != null && String(key) === String(inKey)) {

            data.quantity = data.quantity + action.payload.quantity;
          }
          return data
        });
        return {
          ...state,
          cart: nextCartInc,
          deliveryFee: computeDeliveryFee(nextCartInc),
        };
      }
      const nextCartAdd = [...cartItems, action.payload];
      return {
        ...state,
        cart: nextCartAdd,
        deliveryFee: computeDeliveryFee(nextCartAdd),
        couponAmount: RESET_COUPON,
      }
    }
    case GET_ADDRESS:
      return { ...state, address: action.payload }

    case UPDATE_CART: {

      const updatedCart = state.cart.map((data) => {
        const dataKey = data?.product?.id ?? data?.product?.uuid;
        const payloadKey = action.payload?.product?.id ?? action.payload?.product?.uuid;
        if (dataKey != null && payloadKey != null && String(dataKey) === String(payloadKey)) {
          data.quantity = action.payload.value;
        }
        return data;
      });
      return {
        ...state,
        cart: updatedCart,
        deliveryFee: computeDeliveryFee(updatedCart),
        couponAmount: RESET_COUPON,
      }
    }
    // const findProduct = state.cart.find(({ product }) => product?.uuid === action.payload?.product.uuid);
    // findProduct.quantity = action.payload.value;  devliveryFee

    // const newCart = state.cart.filter(({ product }) => product?.uuid !== action.payload.product.uuid);
    // return { ...state, cart: [...newCart, findProduct], };

    case GET_CART: {
      const cartItemsForFee = action.payload?.items ?? action.payload ?? [];

      return {
        ...state,
        loading: false,
        productLoading: false,
        cart: action.payload?.items ?? action.payload,
        total: action.payload?.total,
        cartId: action.payload?.uuid,
        couponAmount: RESET_COUPON,
        deliveryFee: computeDeliveryFee(cartItemsForFee),
      };
    }
    case DELETE_ADDRESS:
      return {
        ...state,
        address: state.address.filter((item) => item?.uuid !== action.payload),
        loading: false,
      }
    case REMOVE_FROM_CART: {
      const remaining = state.cart.filter(({ product }) => {
        const key = product?.id ?? product?.uuid;
        const removeKey = action.payload?.product?.id ?? action.payload?.product?.uuid;
        if (key == null || removeKey == null) return true;
        return String(key) !== String(removeKey);
      });
      return {
        ...state,
        cart: remaining,
        deliveryFee: remaining.length ? computeDeliveryFee(remaining) : 0,
        couponAmount: RESET_COUPON,
      };
    }

    default:
      return state;
  }
};

export default businessReducer;




